import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faMapMarkerAlt, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  // Mobile Footer
  if (isMobile) {
    return (
      <footer className="bg-gray-800 text-white">
        <div className="container mx-auto px-4 py-6">
          {/* Company Info - Always visible on mobile */}
          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">Zakku</h3>
            <p className="text-gray-300 text-sm mb-4">
              Premium furniture for modern living spaces.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FontAwesomeIcon icon={faFacebook} size="lg" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FontAwesomeIcon icon={faTwitter} size="lg" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FontAwesomeIcon icon={faLinkedin} size="lg" />
              </a>
            </div>
          </div>

          {/* Accordion Sections for mobile */}
          <div className="space-y-2">
            {/* Quick Links Accordion */}
            <div className="border-b border-gray-700 pb-2">
              <button
                className="w-full flex justify-between items-center py-3 text-left"
                onClick={() => toggleSection('quick-links')}
              >
                <h4 className="text-base font-semibold">Quick Links</h4>
                <FontAwesomeIcon 
                  icon={openSection === 'quick-links' ? faChevronUp : faChevronDown} 
                  className="text-gray-400"
                />
              </button>
              {openSection === 'quick-links' && (
                <ul className="space-y-2 pb-3">
                  <li>
                    <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/products" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      Products
                    </Link>
                  </li>
                  <li>
                    <Link to="/collections" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      Collections
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link to="/showrooms" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      Showrooms
                    </Link>
                  </li>
                </ul>
              )}
            </div>

            {/* Customer Service Accordion */}
            <div className="border-b border-gray-700 pb-2">
              <button
                className="w-full flex justify-between items-center py-3 text-left"
                onClick={() => toggleSection('customer-service')}
              >
                <h4 className="text-base font-semibold">Customer Service</h4>
                <FontAwesomeIcon 
                  icon={openSection === 'customer-service' ? faChevronUp : faChevronDown} 
                  className="text-gray-400"
                />
              </button>
              {openSection === 'customer-service' && (
                <ul className="space-y-2 pb-3">
                  <li>
                    <Link to="/faq" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link to="/shipping" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      Shipping Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/returns" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      Returns & Exchanges
                    </Link>
                  </li>
                  <li>
                    <Link to="/warranty" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      Warranty
                    </Link>
                  </li>
                  <li>
                    <Link to="/support" className="text-gray-300 hover:text-white transition-colors text-sm block py-1">
                      Support
                    </Link>
                  </li>
                </ul>
              )}
            </div>

            {/* Contact Info Accordion */}
            <div className="border-b border-gray-700 pb-2">
              <button
                className="w-full flex justify-between items-center py-3 text-left"
                onClick={() => toggleSection('contact-info')}
              >
                <h4 className="text-base font-semibold">Contact Us</h4>
                <FontAwesomeIcon 
                  icon={openSection === 'contact-info' ? faChevronUp : faChevronDown} 
                  className="text-gray-400"
                />
              </button>
              {openSection === 'contact-info' && (
                <ul className="space-y-3 pb-3">
                  <li className="flex items-start space-x-3">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-300 mt-1 flex-shrink-0" />
                    <span className="text-gray-300 text-sm">123 Design Street, Furniture City, FC 12345</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <FontAwesomeIcon icon={faPhone} className="text-gray-300" />
                    <span className="text-gray-300 text-sm">+1 (555) 123-4567</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <FontAwesomeIcon icon={faEnvelope} className="text-gray-300" />
                    <span className="text-gray-300 text-sm">support@zakku.com</span>
                  </li>
                </ul>
              )}
            </div>
          </div>

          {/* Bottom Section */}
          <div className="mt-8 pt-6 border-t border-gray-700">
            <div className="text-gray-400 text-xs mb-4 text-center">
              &copy; {new Date().getFullYear()} Zakku. All rights reserved.
            </div>
            
            <div className="flex flex-wrap justify-center gap-4 mb-4">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-xs transition-colors">
                Privacy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-xs transition-colors">
                Terms
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-white text-xs transition-colors">
                Cookies
              </Link>
              <Link to="/sitemap" className="text-gray-400 hover:text-white text-xs transition-colors">
                Sitemap
              </Link>
            </div>
            
            <div className="text-center text-gray-500 text-xs">
              <p>This website is for demonstration purposes only.</p>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  // Desktop Footer
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Zakku</h3>
            <p className="text-gray-300 mb-4 text-sm">
              Transforming spaces with premium furniture that combines style, comfort, and functionality.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FontAwesomeIcon icon={faFacebook} size="lg" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FontAwesomeIcon icon={faTwitter} size="lg" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FontAwesomeIcon icon={faLinkedin} size="lg" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/collections" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Collections
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/showrooms" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Showrooms
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Customer Service</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-white transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Shipping Policy
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link to="/warranty" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Warranty
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-300 mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">123 Design Street, Furniture City, FC 12345</span>
              </li>
              <li className="flex items-center space-x-3">
                <FontAwesomeIcon icon={faPhone} className="text-gray-300" />
                <span className="text-gray-300 text-sm">+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center space-x-3">
                <FontAwesomeIcon icon={faEnvelope} className="text-gray-300" />
                <span className="text-gray-300 text-sm">support@zakku.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} Zakku. All rights reserved.
            </div>
            
            <div className="flex flex-wrap justify-center space-x-6">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-white text-sm transition-colors">
                Cookie Policy
              </Link>
              <Link to="/sitemap" className="text-gray-400 hover:text-white text-sm transition-colors">
                Sitemap
              </Link>
            </div>
          </div>
          
          <div className="text-center text-gray-500 text-xs mt-4">
            <p>This website is for demonstration purposes only.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;